import { contactData } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          联系我们
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-2">
          {contactData.subtitle}
        </p>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          {contactData.description}
        </p>

        <div className="max-w-2xl mx-auto">
          <div className="flex flex-col sm:flex-row gap-6 mb-8">
            <div className="flex-1 flex items-center gap-4 p-5 bg-background-50 border border-background-200/60 rounded-lg">
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 shrink-0">
                <i className="ri-mail-line text-lg"></i>
              </span>
              <div>
                <p className="text-xs text-foreground-500 mb-0.5">电子邮箱</p>
                <p className="text-sm font-medium text-foreground-800">{contactData.email}</p>
              </div>
            </div>
            <div className="flex-1 flex items-center gap-4 p-5 bg-background-50 border border-background-200/60 rounded-lg">
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 shrink-0">
                <i className="ri-wechat-line text-lg"></i>
              </span>
              <div>
                <p className="text-xs text-foreground-500 mb-0.5">微信</p>
                <p className="text-sm font-medium text-foreground-800">{contactData.wechat}</p>
              </div>
            </div>
          </div>

          <div className="bg-background-50 border border-background-200/60 rounded-lg p-5">
            <p className="text-sm font-medium text-foreground-800 mb-3">投稿与合作须知</p>
            <ul className="space-y-2">
              {contactData.tips.map((tip, i) => (
                <li key={i} className="flex items-start gap-2 text-sm text-foreground-600">
                  <span className="text-accent-500 mt-0.5 shrink-0">
                    <i className="ri-checkbox-circle-line"></i>
                  </span>
                  {tip}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}